const env = {
  FIREBASE_API_KEY: import.meta.env.REACT_APP_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: import.meta.env.REACT_APP_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: import.meta.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: import.meta.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: import.meta.env.REACT_APP_FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: import.meta.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  ADMIN_TOKEN: import.meta.env.ADMIN_TOKEN,
}

export default env
